import db from "../../../../database";
import moment from "moment";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { upsertTableStatus, cancelFBOrder, upsertTableReservation, upsertFBOrder, getFBOrder } from "../../../../services/index";
import { v4 as uuidv4 } from "uuid";
import { generateFormattedKOTs } from "../../../../utility/generateKOTs";

const SyncData = async (item, type, setLoading, status, IPOrder, cart) => {
  const serverUrl = process.env.REACT_APP_serverUrl;
  const authHeaders = getOAuthHeaders();
  const generateMergeId = () => uuidv4().replace(/-/g, "").toUpperCase();
  let token;
  if (authHeaders) {
    token = authHeaders.access_token;
  }
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const username = localStorage.getItem("username");
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  const matchedRep = salesReps.find((rep) => rep.name === username);
  if (type === "upsertTableStatus") {
    let mergeString = "[]";
    if (item.merge && item.merge.length > 0) {
      mergeString =
        "[" +
        item.merge
          .map(
            (m) => `{
            fbMergeId:"${m.fbMergeId || generateMergeId()}"
            fbMTableId:"${m.fbMTableId || m.tableId}"
            fbMergeReason:"${m.fbMergeReason || m.reason || ""}"
          }`
          )
          .join(",") +
        "]";
    }

    let splitTablesString = "[]";
    if (item.splitTables && item.splitTables.length > 0) {
      splitTablesString =
        "[" +
        item.splitTables
          .map(
            (s) => `{
        splitTable:"${s.splitTable || ""}"
        status:"${s.status || "OPN"}"
        guests:${s.guests || 0}
        guestName:"${s.guestName || ""}"
        guestType:"${s.guestType || ""}"
        ${s.salesRepId ? `salesRepId:"${s.salesRepId}"` : ""}
      }`
          )
          .join(",") +
        "]";
    }

    const salesRepIdToSend = item.waiter || matchedRep?.salesRepresentId || null;

    const paramsInput = {
      query: `mutation {
                  upsertTableStatus(tableStatus: {
                    cSBunitID: "${tillData.tillAccess.csBunit.csBunitId}"
                    fbtableStatusId: ${item.fbtableStatusId ? `"${item.fbtableStatusId}"` : null}
                    fbTableId: "${item.cwrFbTableId}"
                    fbSectionId: "${item.cwrFbsectionId}"
                    status: "${item.statusType}"
                    guests: ${item.noOfPersons || 0}
                    guestName: "${item.guestName || ""}"
                    guestType: "${item.guestType || ""}"
                    referredBy: "${item.referredBy || ""}"
                    salesRepId: ${salesRepIdToSend ? `"${salesRepIdToSend}"` : null}
                    merge: ${mergeString}
                    splitTables: ${splitTablesString}
                    ${item.splitTable ? `splitTable: "${item.splitTable}"` : ""}
                   }) { 
                status
                message   
                }
                }`,
    };
try {
  console.log("🚀 CALLING API upsertTableStatus");

  const response = await upsertTableStatus(paramsInput);

  console.log("✅ API RESPONSE:", response);

  const status = response?.data?.data?.upsertTableStatus?.status;

  if (status === "200") {
    console.log("✅ STATUS 200 RECEIVED");

    let allTableData = await db.tableData.toArray();
    let data = [];

    allTableData.forEach((ele) => {
      if (item.cwrFbTableId === ele.cwrFbTableId && item.statusType === "OPN") {
        ele.ordered = "N";
        ele.statusType = "OPN";
        ele.color = "#a7c957";
        ele.tabbleSync = "Y";
      }
      data.push(ele);
    });

    await db.tableData.clear();
    await db.tableData.bulkPut(data);

    return { success: true }; // ✅ VERY IMPORTANT
  }

  console.warn("⚠️ STATUS NOT 200:", status);
  return { success: false };

} catch (err) {
  console.error("❌ SyncData ERROR:", err);
  return { success: false, error: err }; // ✅ VERY IMPORTANT
}
  } else if (type === "cancelItem") {
    const cancelItemsData = {
      query: `mutation {
                cancelFBOrder(fbOrder: {
                  fbOrderId:"${item.fbOrderId}"
                  lines:[${item.cancelItems}]
                 }) { 
              status
              message   
              }
              }`,
    };
    await cancelFBOrder(cancelItemsData);
  } else if (type === "reservation") {
    const fbTableIdValue = item.cwrFbTableId || item.tableId || null;
    const fbSectionIdValue = item.cwrFbsectionId || item.sectionId || null;
    const paramsInput = {
      query: `mutation {
              upsertTableReservation(tableReservation: {
                cSBunitID: "${tillData.tillAccess.csBunit.csBunitId}"
                fbTableReservationId: "${item.uniqueId ? item.uniqueId : item.id}"
                fbTableId: ${fbTableIdValue ? `"${fbTableIdValue}"` : null}
                fbSectionId: ${fbSectionIdValue ? `"${fbSectionIdValue}"` : null}
                customerName: "${item.name === undefined ? "" : item.name}"
                noOfPeople: "${item.noOfPersons ? item.noOfPersons : item.guests}"
                ${item.mobile || item.phone ? `contactNo: "${item.mobile || item.phone}"` : ""},
                ${item.guestType ? `guestType: "${item.guestType}"` : ""},
                ${item.referredBy ? `referredBy: "${item.referredBy}"` : ""},
                ${item.status ? `status: "${item.status}"` : ""},
                 resDate: "${
                   typeof item.time === "string" && item.time.includes("/") ? moment(item.time, "DD/MM/YYYY, hh:mm A").format("YYYY-MM-DD") : moment(item.time).format("YYYY-MM-DD")
                 }"

    resTime: "${
      typeof item.time === "string" && item.time.includes("/")
        ? moment(item.time, "DD/MM/YYYY, hh:mm A").format("YYYY-MM-DD HH:mm:ss")
        : moment(item.time).format("YYYY-MM-DD HH:mm:ss")
    }"
               }) { 
            status
            message   
            }
            }`,
    };
    await upsertTableReservation(paramsInput);
  } else if (type === "upsertFbOrder") {
    try {
    if (setLoading) setLoading(true);
    console.log("cart", cart);
    const cartDetails = JSON.parse(localStorage.getItem("cartObj"));
    const tableName = JSON.parse(localStorage.getItem("tableName"));
    const dineIn = localStorage.getItem("dineIn");

    const cartItems = { ...cartDetails, tableNo: tableName?.name ? tableName?.name : "" };
    const cartMetaValue = JSON.stringify(JSON.stringify(cartItems));
    const fbOrderMetaId = uuidv4().replace(/-/g, "").toUpperCase();
    const fbOrders = JSON.parse(localStorage.getItem("getFBOrderData") || "[]");

    // let lastDocumentNo = null;
    // let tempResponse = null;

    // await db.fbOrderData
    //   .where("fbOrderSync")
    //   .equals("N")
    //   .toArray()
    //   .then(async (orders) => {
    //     if (orders.length === 0) return;

    //     for (let i = 0; i < orders.length; i++) {
    //       const o = orders[i];
        let tempResponse = null;

        // ✅ Use item directly — no DB query needed
        const orders = Array.isArray(item) ? item : [item];

        if (orders.length > 0) {
          for (let i = 0; i < orders.length; i++) {
            const o = orders[i];

          let metaString = "[]";
          if (IPOrder && o.isCanceled !== "Y") {
            metaString = `[
            {
              fbOrderMetaId: "${fbOrderMetaId}"
              key: "cartDetails"
              value: ${cartMetaValue}
            }
          ]`;
          }

          const filteredOrders = Array.isArray(fbOrders) ? fbOrders.filter((fo) => fo.fbTableId === o.cwrFbTableId || fo.fbTableId === o.fbTableId) : [];

          let selectedProductIds = [];
          if (Array.isArray(o.lines)) {
            selectedProductIds = o.lines
              .filter(
                (line) =>
                  line &&
                  line.fbOrderLineId &&
                  line.fbOrderLineId !== "undefined" &&
                  line.mPoductId &&
                  line.mPoductId !== "undefined" &&
                  line.csUomId &&
                  line.csUomId !== "undefined" &&
                  line.csTaxId &&
                  line.csTaxId !== "undefined"
              )
              .map((line) => line.lineId);
          }

          let mergeString = "[]";
          if (o.mergeTables && o.mergeTables.length > 0) {
            mergeString =
              "[" +
              o.mergeTables
                .map(
                  (m) => `{
                  fbMergeId:"${generateMergeId()}"
                  fbMergeReason:"${m.reason}"
                  fbMTableId:"${m.tableId}"
                }`
                )
                .join(",") +
              "]";
          }

          let linesString = "[]";
          if (Array.isArray(o.lines) && o.lines.length > 0 && typeof o.lines[0] === "object") {
            const formattedLines = o.lines.map((line) => {
              const lineMetaString = line.meta
                ? line.meta
                    .map(
                      (m) => `{
                      fbOrderLineMetaId:"${m.fbOrderLineMetaId || ""}"
                      key:"${m.key}"
                      value:${JSON.stringify(m.value)}
                    }`
                    )
                    .join(",")
                : "";

              return `{
              fbOrderId: "${o.fbOrderId}"
              fbOrderLineId: "${line.fbOrderLineId}"
              mPoductId: "${line.mPoductId}"
              mBatchId: ${line.mBatchId ? `"${line.mBatchId}"` : null}
              description: "${line.description || ""}"
              csUomId: "${line.csUomId}"
              csTaxId: "${line.csTaxId}"
              discount:${line.discount ?? 0}
              line:${line.line ?? 0}
              qty:${line.qty ?? 0}
              unitPrice:${line.unitPrice ?? 0}
              listPrice:${line.listPrice ?? 0}
              lineNet:${line.lineNet ?? 0}
              lineTax:${line.lineTax ?? 0}
              lineGross:${line.lineGross ?? 0}
              sOrderLineId:${line.sOrderLineId ? `"${line.sOrderLineId}"` : null}
              isOrdered:"${line.isOrdered || "N"}"
              isCanceled:"${line.isCanceled || "N"}"
              remarks: "${line.remarks || ""}"
              grossStd:${line.grossStd || 0}
              grossUnit:${line.grossUnit || 0}
              lineStd:${line.lineStd || 0}
              netList:${line.netList ?? 0}
              netStd:${line.netStd ?? 0}
              netUnit:${line.netUnit || 0}
              unitTax:${line.unitTax ?? 0}
              meta:[${lineMetaString}]
            }`;
            });

            linesString = `[${formattedLines.join(",")}]`;
          }

          const skipKots = o.fbOrderStatus !== "IP";
          const formattedKots = skipKots ? [] : generateFormattedKOTs(cartDetails, tillData, selectedProductIds);
          const kotsSection = skipKots ? "" : `kots:[${formattedKots.join(",")}]`;

          const paramsInput = {
            query: `mutation {
            upsertFBOrder(order: {
              cSBunitID: "${tillData.tillAccess.csBunit.csBunitId}"
              fbOrderId: "${o.fbOrderId}"
              fbTableId: "${o.cwrFbTableId}"
              fbSectionId: ${o.cwrFbsectionId ? `"${o.cwrFbsectionId}"` : null}
              sOrderId: null
              isCanceled: "${o.isCanceled || "N"}"
              orderNo: null
              date: "${moment().format("YYYY-MM-DD HH:mm:ss")}"
              status: "${o.fbOrderStatus}"
              merge: ${mergeString}
              meta: ${metaString}
              lines: ${linesString}
              ${kotsSection}
            }) {
              status
              message
              documentNo
            }
          }`,
          };

          const response = await upsertFBOrder(paramsInput);

          if (response) {
                      // ✅ REMOVED db.fbOrderData.modify — caller handles DB write on success
                      localStorage.removeItem("cancelKOTRemarks");
                      const documentNo = response?.data?.data?.upsertFBOrder?.documentNo;
                      if (documentNo) {
                        localStorage.setItem("orderId", documentNo);
                      }
                      tempResponse = response;
                    }
                  }
            } // ✅ close for loop

            return tempResponse;
  } catch (error) {
    console.error("❌ upsertFbOrder error:", error);
    return null;
  } finally {
    if (setLoading) setLoading(false);
  }
    // return lastDocumentNo;
  } else if (type === "getFbOrder") {
    const paramsInput = {
      query: `query {
        getFBOrder(
          tableId: "${item.tableId}"
          status: "${item.status}"
        ) {
          fbOrderId
          cSBunitID
          isactive
          sOrderId
          fbTableId
          orderNo
          fbSectionId
          date
          guests
          guestType
          salesRepId
          guestName
          referredBy
          status
          isCanceled
          discAmount
          fbSplitTable
          merge {
            fbMergeId
            fbMergeReason
            fbTableId
          }
          lines {
            fbOrderLineId
            line
            mPoductId
            mBatchId
            description
            csUomId
            qty
            unitPrice
            listPrice
            csTaxId
            lineTax
            lineGross
            isOrdered
            sOrderLineId
            isCanceled
            discount
            mPricingRuleId
            name
            value
            grossStd
            grossUnit
            lineStd
            netList
            netStd
            netUnit
            unitTax
            meta {
              fbOrderLineMetaId
              key
              value
            }
          }
          meta {
            fbOrderMetaId
            key
            value
          }
        }
      }`,
    };

    return await getFBOrder(paramsInput);
  }
};

export { SyncData };
